const LOCAL_STORAGE_PREFIX = 'admin-protocol-editor';

export const LS_NOTIFICATION_TEMPLATES_KEY = `${LOCAL_STORAGE_PREFIX}:notification-templates`;

export const LS_DSL_SOURCE_KEY = `${LOCAL_STORAGE_PREFIX}:dsl-source`;

export const LS_FIELDS_DATA_JSON_KEY = `${LOCAL_STORAGE_PREFIX}:fields-data-json`;

export const LS_CONTEXT_DATA_JSON_KEY = `${LOCAL_STORAGE_PREFIX}:context-data-json`;

export const LS_STYLING_CSS_KEY = `${LOCAL_STORAGE_PREFIX}:styling-css`;

export const LS_BRAND_KEY = `${LOCAL_STORAGE_PREFIX}:brand`;

export const LS_TRANSLATIONS_KEY = `${LOCAL_STORAGE_PREFIX}:translations`;
